var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ProgressStore from "./common/progress";
import ProblemStore from "./stepsItems/problem";
import DetailStore from "./stepsItems/detail";
import AvailabilityStore from "./stepsItems/availability";
import QuestionsStore from "./stepsItems/question";
import CommonStore from "./common/common";
import HomeStore from "./common/home";
import http, { Api, Q } from "@http";
import { observable, action, runInAction, toJS } from "mobx";
import DuplicateCheckStore from "./duplicateCheck/duplicateCheckStore";
import ReviewStore from './stepsItems/review';
import { isEmpty } from "@common/utils";
import RecallCheckStore from "./recallCheck/recallCheckStore";
import { PredefinedServiceCategory, RecallSourceType, PostMessageType } from "@common/enums";
import moment from "moment";
import { AvailabilityType } from "@common/enums/availability";
import { iframePostMessage } from '@common/utils';
var RSPRecall = RecallSourceType.RSPRecall;
var InternalCAH = PredefinedServiceCategory.InternalCAH, ProCare = PredefinedServiceCategory.ProCare;
var RequestMaintenanceStore = /** @class */ (function () {
    function RequestMaintenanceStore() {
        this.availabilityStore = new AvailabilityStore();
        this.questionsStore = new QuestionsStore();
        this.commonStore = new CommonStore(this.questionsStore);
        this.loading = false;
        this.submitData = {};
        this.homeStore = new HomeStore();
        this.progressStore = new ProgressStore();
        this.problemStore = new ProblemStore();
        this.detailStore = new DetailStore();
        this.duplicateCheckStore = new DuplicateCheckStore();
        this.recallCheckStore = new RecallCheckStore();
        this.reviewStore = new ReviewStore();
    }
    RequestMaintenanceStore.prototype.getRecallDto = function (originalWOId) {
        var _a = this.availabilityStore, isInHouseTechnician = _a.isInHouseTechnician, isRecallLessen = _a.isRecallLessen;
        var isRecallCheck = this.commonStore.isRecallCheck;
        var serviceCategoryId = this.problemStore.serviceCategoryId;
        var isExcludeCategory = [ProCare, InternalCAH].includes(serviceCategoryId);
        if (isRecallCheck === null || isExcludeCategory)
            return null;
        if (isInHouseTechnician && !isRecallLessen)
            return null;
        var formatWOId = originalWOId ? Number(originalWOId) : null;
        return {
            recallWO: {
                recallSourceType: RSPRecall,
                originalWOId: formatWOId,
                isCertifiedRecall: isRecallCheck,
                isSelectNotRecall: !isRecallCheck,
            },
        };
    };
    RequestMaintenanceStore.prototype.getDuplicateDto = function () {
        var duplicateWOList = this.duplicateCheckStore.duplicateWOList;
        var isDupCheck = this.commonStore.isDupCheck;
        if (isDupCheck === null)
            return null;
        return {
            duplicateWO: {
                isExistOpenWO: !isEmpty(duplicateWOList),
                isSelectDuplicate: isDupCheck,
                isEnableDuplicateCheck: true // default true, is related to feature toggle, dup-check is standard procedure now
            }
        };
    };
    RequestMaintenanceStore.prototype.submit = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var keyQuestionAnswers, troubleShootingAnswers, woAttachments, _b, regionScriptWoTypeId, woTypeId, regionScriptPriority, autoScheduleModel, residentPreferredSchedule, priority, contactPhone, contactFlagofPhonesForTextMessagingApproved, autoScheduleRawData, _c, problemCaseCadeName, serviceCombinationAliasId, serviceCategoryId, serviceTypeId, serviceCodeId, originWO, isRecallCheck, data, promise, result;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.loading = true;
                        keyQuestionAnswers = this.questionsStore.keyQuestionsCommitData;
                        troubleShootingAnswers = this.questionsStore.troubleShootingCommitData;
                        woAttachments = toJS(this.detailStore.attachmentList).map(function (attachment) { return ({
                            FileName: attachment.fileName,
                            FilePath: attachment.filePath,
                            Checked: false,
                            RefType: '0',
                            ContentType: attachment.contentType
                        }); });
                        _b = this.availabilityStore, regionScriptWoTypeId = _b.regionScriptWoTypeId, woTypeId = _b.woTypeId, regionScriptPriority = _b.regionScriptPriority, autoScheduleModel = _b.autoScheduleModel, residentPreferredSchedule = _b.residentPreferredSchedule, priority = _b.priority, contactPhone = _b.contactPhone, contactFlagofPhonesForTextMessagingApproved = _b.contactFlagofPhonesForTextMessagingApproved, autoScheduleRawData = _b.autoScheduleRawData;
                        _c = this.problemStore, problemCaseCadeName = _c.problemCaseCadeName, serviceCombinationAliasId = _c.serviceCombinationAliasId, serviceCategoryId = _c.serviceCategoryId, serviceTypeId = _c.serviceTypeId, serviceCodeId = _c.serviceCodeId;
                        originWO = this.recallCheckStore.originWO;
                        isRecallCheck = this.commonStore.isRecallCheck;
                        data = __assign(__assign({ attachments: woAttachments, wo: {
                                problemDescription: isRecallCheck ? originWO.problems : problemCaseCadeName,
                                AddtionalDetail: this.detailStore.additionalDetail,
                                woTypeId: regionScriptWoTypeId ?
                                    regionScriptWoTypeId : woTypeId,
                                priorityId: regionScriptPriority ?
                                    regionScriptPriority : priority,
                            }, commonAnswer: keyQuestionAnswers, serviceCodeAnswer: troubleShootingAnswers, residentPreferredSchedule: {}, contact: {
                                phone: contactPhone,
                                flagofPhonesForTextMessagingApproved: contactFlagofPhonesForTextMessagingApproved && (contactPhone === null || contactPhone === void 0 ? void 0 : contactPhone.length) > 0 ? '1,0,0,0,0,0,0' : null
                            }, serviceCombinationAliasId: serviceCombinationAliasId, serviceCategoryId: serviceCategoryId, serviceTypeId: serviceTypeId, serviceCodeId: serviceCodeId, autoScheduleModel: __assign(__assign({}, toJS(autoScheduleModel)), { recommendAffiliateType: autoScheduleRawData.recommendAffiliateType, recommendKey: autoScheduleRawData.recommendKey, submissionPayload: __assign({}, autoScheduleRawData.submissionPayload), recommendReason: autoScheduleRawData.recommendReason }), serviceRequestId: isRecallCheck ? originWO.serviceRequestId : null }, this.getRecallDto(originWO.woId)), this.getDuplicateDto());
                        promise = this.api().simpleCommit(data);
                        return [4 /*yield*/, promise];
                    case 1:
                        result = _d.sent();
                        runInAction(function () {
                            var _a;
                            _this.loading = false;
                            if (typeof result === 'string') {
                                _this.showNotification('Internal service error');
                            }
                            if (result === null || result === void 0 ? void 0 : result.isSuccess) {
                                var id = (_a = result === null || result === void 0 ? void 0 : result.body) === null || _a === void 0 ? void 0 : _a.id;
                                _this.submitData = result === null || result === void 0 ? void 0 : result.body;
                                _this.availabilityStore.logRegionalScriptChange(id);
                                _this.preferredSchedule(id);
                                _this.problemStore.createWoServiceComboEventlog(id);
                                iframePostMessage(PostMessageType.WoCreate_submit);
                            }
                            else {
                                _this.showNotification(result === null || result === void 0 ? void 0 : result.msg);
                            }
                        });
                        this.availabilityStore.urgentScheduleRecommandTrack((_a = result === null || result === void 0 ? void 0 : result.body) === null || _a === void 0 ? void 0 : _a.id, data.wo.priorityId);
                        return [2 /*return*/, result === null || result === void 0 ? void 0 : result.body];
                }
            });
        });
    };
    RequestMaintenanceStore.prototype.showNotification = function (content) {
        window.notificationManager.show({
            title: 'Something was wrong',
            type: "danger",
            position: "top-right",
            content: content,
        });
    };
    RequestMaintenanceStore.prototype.preferredSchedule = function (woId) {
        var _a = this.availabilityStore, availabilityType = _a.availabilityType, selectedAvailabilityTimes = _a.selectedAvailabilityTimes;
        var availabilityTypeList = [AvailabilityType.Flexible, AvailabilityType.Limited];
        if (availabilityTypeList.indexOf(availabilityType) === -1 || !woId || woId === '0' || woId === 0) {
            return false;
        }
        var residentPreferredScheduleTimes = selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).map(function (x) {
            var date = moment(x.date).format('YYYY MM DD');
            var times = x.timeQuantumValue.split(' - ');
            var start = moment(date + " " + times[0]).format('YYYY-MM-DD HH:mm:ss');
            var end = moment(date + " " + times[1]).format('YYYY-MM-DD HH:mm:ss');
            return {
                localStartTime: start,
                localEndTime: end
            };
        });
        var postData = {
            reactiveWoId: woId,
            residentPreferredScheduleType: availabilityType,
            residentPreferredScheduleTimes: residentPreferredScheduleTimes
        };
        this.api().createResidentPreferredSchedule(postData);
    };
    RequestMaintenanceStore.prototype.api = function () {
        return {
            simpleCommit: function (data) {
                return Q(http.post("/RSP/NewRequest/reactiveWo/SimpleCommit", data, __assign({}, Api.withForm)));
            },
            createResidentPreferredSchedule: function (params) {
                return Q(http.post("/RSP/ResidentPreferredSchedule/CreateResidentPreferredSchedule", params));
            },
        };
    };
    __decorate([
        observable
    ], RequestMaintenanceStore.prototype, "availabilityStore", void 0);
    __decorate([
        observable
    ], RequestMaintenanceStore.prototype, "questionsStore", void 0);
    __decorate([
        observable
    ], RequestMaintenanceStore.prototype, "commonStore", void 0);
    __decorate([
        observable
    ], RequestMaintenanceStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], RequestMaintenanceStore.prototype, "submitData", void 0);
    __decorate([
        action.bound
    ], RequestMaintenanceStore.prototype, "submit", null);
    return RequestMaintenanceStore;
}());
export default RequestMaintenanceStore;
